import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

export default function DeviceDetail() {
  const { t } = useTranslation();
  const { id } = useParams();
  return (
    <Box>
      <Typography variant='h2' sx={{ color: 'primary.main', textAlign: 'left' }}>{t('deviceDetail.title', { id })}</Typography>
      {t('deviceDetail.details', { id })}
    </Box>
  );
}
